import { useState } from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";

const TwoStepLogin = () => {
  const [userInfo, changeUserInfo] = useState({
    Username: "",
    Password: "",
    PIN: "",
  });

  let config = {
    body: JSON.stringify(userInfo),
    method: "POST",
    mode: "cors",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
  };

  const handleChange = (type, data) => {
    if (type === "username")
      changeUserInfo((userInfo) => ({
        ...userInfo,
        Username: data,
      }));
    else if (type === "password")
      changeUserInfo((userInfo) => ({
        ...userInfo,
        Password: data,
      }));
    else if (type === "PIN")
      changeUserInfo((userInfo) => ({
        ...userInfo,
        PIN: data,
      }));
  };

  const submitLogin = () => {
    fetch("/api/admin/auth/identity/authenticate", config).then((response) =>
      response
        .text()
        .then((resource) => ({ resource, response }))
        .then(({ resource, response }) => {
          if (!response.ok) {
            return Promise.reject(resource);
          } else {
            // task init sesion
            var date = new Date();
            var token = JSON.parse(resource);
            date.setSeconds(date.getSeconds() + token.Token.expires_in);
            token.Token.expires_in = date;

            localStorage.setItem("admin.usr", JSON.stringify(token.Token));
            window.location.reload();
          }
        }),
    );
  };

  return (
    <div>
      <TextField
        fullWidth={true}
        style={{ marginTop: "-20px" }}
        size="small"
        label="Username"
        variant="outlined"
        onBlur={(event) => {
          handleChange("username", event.target.value);
        }}
      />
      <TextField
        fullWidth={true}
        style={{ marginTop: "10px" }}
        type="password"
        label="Password"
        size="small"
        variant="outlined"
        onBlur={(event) => {
          handleChange("password", event.target.value);
        }}
      />
      <TextField
        fullWidth={true}
        style={{ marginTop: "10px" }}
        label="PIN"
        size="small"
        variant="outlined"
        onBlur={(event) => {
          handleChange("PIN", event.target.value);
        }}
      />
      <Button
        variant="outlined"
        color="primary"
        fullWidth={true}
        onClick={() => submitLogin()}
      >
        Login
      </Button>
    </div>
  );
};

export default TwoStepLogin;
